<div class="section-title">
  <span class="section-title__number">{{ number() }}</span>
  <div>
    <h3 class="section-title__title">{{ title() | translate }}
      @if (label()) {
      <span class="section-title__title--highlight">{{ label() | translate }}</span>
      }
    </h3>
  </div>
</div>
<p class="section-title__subtitle">{{ subtitle() | translate }}</p>
